import React from 'react';
import styled from '@emotion/styled';

const LoadingIndicatorContainer = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 15px 50px;
  background: rgba(0, 0, 0, 0.9);
  backdrop-filter: blur(20px);
  border-radius: 100px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.4);
  color: white;
  font-size: 1.2rem;
  z-index: 10000;
  display: flex;
  align-items: center;
  gap: 15px;
`;

const LoadingLogo = styled.img`
  height: 60px;
  width: auto;
`;

const LoadingTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const SubtitleText = styled.div`
  font-size: 0.9rem;
  margin-top: 10px;
  opacity: 0.8;
`;

/**
 * Kuutio Loading Indicator Component
 * Shows rotating Kuutio video with customizable loading text
 * 
 * @param {string} text - Main loading text
 * @param {string} subtitle - Optional subtitle text
 * @param {boolean} show - Whether to show the loading indicator
 */
function KuutioLoadingIndicator({ 
  text = "Processing...", 
  subtitle = "",
  show = true 
}) {
  console.log('🔄 KuutioLoadingIndicator:', { show, text, subtitle });
  if (!show) return null;

  return (
    <LoadingIndicatorContainer>
      <LoadingLogo src="/assets/kuutio-logo-rounded.svg" alt="Kuutio" />
      <LoadingTextContainer>
        <div>{text}</div>
        {subtitle && <SubtitleText>{subtitle}</SubtitleText>}
      </LoadingTextContainer>
    </LoadingIndicatorContainer>
  );
}

export default KuutioLoadingIndicator;
export { LoadingIndicatorContainer, LoadingLogo, LoadingTextContainer, SubtitleText };